import { Injectable, OnInit } from "@angular/core"
import { MatDialog } from "@angular/material/dialog"
import {
  CanDeactivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router"
import { LexTranslateService } from "@app/core/services/lex-translate.service"
import { GenericDialogComponent } from "@app/shared/components/generic-dialog/generic-dialog.component"
import { Observable, Subject } from "rxjs"

@Injectable()
export class ModificationGuardService implements CanDeactivate<OnInit> {
  isModifying: () => boolean = () => false
  confirmation$: Subject<boolean>
  onExitSuccessful: Function
  onExitCancelled: Function

  constructor(
    public lextranslate: LexTranslateService,
    private dialog: MatDialog
  ) {}

  canDeactivate(
    component: OnInit,
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.isModifying && this.isModifying()) {
      return this.showConfirmationDialog()
    }
    if (this.onExitSuccessful) {
      this.onExitSuccessful()
    }
    return true
  }

  showConfirmationDialog(): Promise<boolean> {
    return new Promise((resolve) => {
      const dialogRef = this.dialog.open(GenericDialogComponent, {
        data: {
          icon: "warning",
          title: this.lextranslate.i18n["ba7dd5f5-b8c1-4c4f-96a4-45b05663d293"],
          paragraph: this.lextranslate.i18n["d74318ea-d3a2-4a91-a19a-88283ec6f896"],
          question: this.lextranslate.i18n["980ba6aa-39b4-4829-8161-e2cb29db201f"],
        },
        panelClass: "modal-ml",
      });

      dialogRef.afterClosed().subscribe((canClose: boolean) => {
        if (canClose) {
          if (this.onExitSuccessful) {
            this.onExitSuccessful();
          }
          resolve(true);
        } else {
          if (this.onExitCancelled) {
            this.onExitCancelled();
          }
          resolve(false);
        }
      });
    });
  }
}
